module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-video-off-fill-d362226f.svg";